// 常量

export const ROUTES = {
    LOGIN: "login", // Login
    TOKEN_EXPIRED: "401", // TokenExpired
    FORBIDDEN: "403", // Forbidden
    NOT_FOUND: "404", // NotFound
    SERVER_ERROR: "500", // ServerError
    ERROR_PAGE: "error-page", // ErrorPage

    ALARM: "", // アラート管理
    ORGANIZATION: "Organization", // 組織マスタ
    DEPARTMENT: "Department", // 部門マスタ
    USER: "User", // ユーザーマスタ
    CATEGORY: "Category", // カテゴリマスタ
    MATERIAL: "Material", // アイテムマスタ
    JANCODE: "Jancode", // JANコードマスタ
    LOG: "Log", // 履歴マスタ
    SETTINGS: "Settings", // 環境設定
    INVENTORY: "Inventory", // 在庫一覧
    INVENTORY2: "Inventory2", // 在庫一覧
    PAYMENT: "Payment", // 払い出し
    CONSTANT_MANAGE: "ConstantManage", // 定数管理
    CONSTANT_MANAGE2: "ConstantManage2", // 定数管理2
    CHECK_RESULT: "CheckResult", // 期限管理
    PERSONAL_SETTINGS: "PersonalSetting", // 個人設定
};

export const ROLES = {
    SYSTEM: "system", // システム管理者
    ADMIN: "admin", // 管理者
    USER: "user", // ユーザー
};

export const ALL = 'ALL'; // 

export const SYSTEM_ORGANIZATION = 'SYSTEM';

export const screenWidth = 992;

export const IMG_MAX_SIZE = 1024 * 1024 * 5; // 5MB

export const CSV_MAX_SIZE = 1024 * 100; // 100k

export const INVENTORY_CONSTANTS = {
    DEPARTMENT_LEVEL: {
        EXCEED_RANGE: 1000,
        PAGE_SIZE: 5,
    },
    DETAIL_LEVEL: {
        EXCEED_RANGE: 1000,
        PAGE_SIZE: 5,
    }
}

/** アイテムマスタ「無期限」の初期期限（日）。在庫登録時はこの日数なら固定有効期限を入れる */
export const NO_EXPIRY_DAY = 9999;

/** 無期限時の有効期限 */
export const NO_EXPIRY_DATE_ISO = '2999-12-31T00:00:00.000Z';